var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"tw-text-center mb-3"},[_vm._v("\n    Highest Bid:\n    "+_vm._s(_vm.bidCount ? "$" + _vm.highestBidAmountDollarFormat : "N/A")+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }